import React from 'react';
import loadable from '@loadable/component';

export default {
	component: loadable(
		() => import(/* webpackChunkName: "discount" */ './OrderListing'),
		{
			fallback: <div>Loading...</div>
		}
	)
};
